const routes = [
  {
    path: "/manutencao-motivo-substituicao-diretor-secretario",
    name: "manutencao-motivo-substituicao-diretor-secretario",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicaoDiretorSecretario/ManutencaoMotivoSubstituicaoDiretorSecretarioHome.vue"
      ),
  },
  {
    path: "/manutencao-motivo-substituicao-diretor-secretario/novo",
    name: "manutencao-motivo-substituicao-diretor-secretario-novo",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicaoDiretorSecretario/ManutencaoMotivoSubstituicaoDiretorSecretarioCad.vue"
      ),
  },
  {
    path: "/manutencao-motivo-substituicao-diretor-secretario/editar/:id",
    name: "manutencao-motivo-substituicao-diretor-secretario-editar",
    meta: {
      allowedPermissions: ["motivo_afastamento_nomeacao_show"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoMotivoSubstituicaoDiretorSecretario/ManutencaoMotivoSubstituicaoDiretorSecretarioEdit.vue"
      ),
  },
];

export default routes;
